import { render } from "./UsersRoles.vue?vue&type=template&id=04c4c2c8"
import script from "./UsersRoles.vue?vue&type=script&lang=js"
export * from "./UsersRoles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__